import React, { useEffect, useState } from 'react';
import { useHistory, Switch, Route, Redirect } from 'react-router-dom';
import AdvertiserMeetDavie from './AdvertiserMeetDavie';
import ConnectedLearn from './Learn/ConnectedLearn';
import ConnectedCampaignStrategy from './Learn/ConnectedCampaignStrategy';
import usePost from '../../../Hooks/usePost';
import { useAdvertisers } from '../../../Contexts/AdvertisersContext';
import useRequest from '../../../Hooks/useRequest';
import { useProfile } from '../../../Contexts/UserProfileContext';
import AgencyMeetDavie from './AgencyMeetDavie';
const ConnectedTeach = () => {
    const { setShouldFetchOtherData, currentAdvertiser } = useAdvertisers();
    const { profile } = useProfile();
    const selectedAdvertiserId = currentAdvertiser?.advertiserId;

    const role = {
        isAgency: profile.isAgency,
        isAdvertiser: profile.isIndividual,
        isSiteAdmin: profile.isSiteAdmin,
    };

    const { post } = usePost(`/SaveTeachDavieDataByAdvertiser`);
    const { data: getTeachDavieData, mutate } = useRequest(
        `/GetTeachDavieDataByAdvertiser/${selectedAdvertiserId}`
    );
    const [teachDavieData, setTeachDavieData] = useState({
        websiteURL: '',
        category: '',
        doYouHaveStore: '',
        doYouHaveWebsite: '',
        primaryProduct: '',
        otherProducts: '',
        acceptTelephoneOrders: '',
        doYouShip: '',
        whoAreCustomers: {
            consumers: false,
            businesses: false,
            institutions: false,
            governments: false,
        },
        describeBestCustomer: '',
        budget: 100,
    });

    const [postData, setPostData] = useState({
        success: false,
        error: false,
        isLoading: false,
        message: '',
    });

    const {
        websiteURL,
        category,
        doYouHaveStore,
        doYouHaveWebsite,
        primaryProduct,
        otherProducts,
        acceptTelephoneOrders,
        doYouShip,
        whoAreCustomers: { consumers, businesses, institutions, governments },
        describeBestCustomer,
        budget,
    } = { ...teachDavieData };

    const saveTeachDavieData = async () => {
        const body = {
            advertiserId: selectedAdvertiserId,
            versionNo: 1,
            websiteURL: websiteURL !== null ? websiteURL : '',
            category: category !== null ? category : '',
            doYouHaveStore: doYouHaveStore !== null ? doYouHaveStore : '',
            doYouHaveWebsite: doYouHaveWebsite !== null ? doYouHaveWebsite : '',
            primaryProduct: primaryProduct !== null ? primaryProduct : '',
            otherProducts: otherProducts !== null ? otherProducts : '',
            acceptTelephoneOrders: acceptTelephoneOrders !== null ? acceptTelephoneOrders : '',
            doYouShip: doYouShip !== null ? doYouShip : '',
            whoAreCustomers: {
                consumers: consumers !== null ? consumers : '',
                businesses: businesses !== null ? businesses : '',
                institutions: institutions !== null ? institutions : '',
                governments: governments !== null ? governments : '',
            },
            describeBestCustomer: describeBestCustomer !== null ? describeBestCustomer : '',
            budget: budget !== null ? budget : 0,
        };

        try {
            setPostData({ ...postData, isLoading: true });
            const teachDavieResp = await post(body, 'POST');
            await mutate();
            if (teachDavieResp.data) {
                setShouldFetchOtherData(true);
                setPostData({
                    isLoading: false,
                    success: true,
                    error: false,
                    message: 'Successful',
                });
            } else {
                setPostData({
                    isLoading: false,
                    success: false,
                    error: true,
                    message: 'Something went wrong',
                });
            }
        } catch (err) {
            setPostData({
                isLoading: false,
                success: false,
                error: true,
                message: 'Something went wrong',
            });
        }
    };

    const resetFields = () => {
        if (getTeachDavieData) {
            setTeachDavieData({ ...getTeachDavieData });
        }
    };

    useEffect(() => {
        resetFields();
    }, [getTeachDavieData]);

    return (
        <div>
            <Switch>
                <Route path="/portal/teach/intro">
                    {role.isAgency ? <AgencyMeetDavie /> : <AdvertiserMeetDavie />}
                </Route>
                <Route path="/portal/teach/learn">
                    <ConnectedLearn
                        useHistory={useHistory}
                        teachDavieData={teachDavieData}
                        setTeachDavieData={setTeachDavieData}
                        saveTeachDavieData={saveTeachDavieData}
                        postData={postData}
                    />
                </Route>
                <Route path="/portal/teach/campaignStrategy">
                    <ConnectedCampaignStrategy
                        useHistory={useHistory}
                        teachDavieData={teachDavieData}
                        setTeachDavieData={setTeachDavieData}
                    />
                </Route>
                <Redirect to="/portal/teach/intro" />
            </Switch>
        </div>
    );
};

ConnectedTeach.propTypes = {};

ConnectedTeach.defaultProps = {};

export default ConnectedTeach;
